var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKernelinline = function SvgKernelinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.375,
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.585 19.02 20.98 9.415a1.417 1.417 0 0 0-2.004 0l-1.994 1.995 2.53 2.53a1.682 1.682 0 0 1 2.13 2.145l2.439 2.438a1.685 1.685 0 1 1-1.01.95l-2.274-2.273v5.984q.248.124.446.32a1.686 1.686 0 1 1-1.832-.369v-6.04a1.685 1.685 0 0 1-.915-2.211L16 12.39l-6.586 6.586a1.417 1.417 0 0 0 0 2.004l9.606 9.605c.553.553 1.45.553 2.003 0l9.561-9.56a1.42 1.42 0 0 0 0-2.005"
  })));
};
export default SvgKernelinline;